/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IFrame } from '@jutro/components';
import _ from 'lodash';
import messages from './MLCreditCardDetailsComponent.messages';
import styles from './MLCreditCardDetailsComponent.module.scss';
import appConfig from 'app-config';

import { CheckboxField } from '@jutro/legacy/components';

// ML: MLCreditCardDetailsDirectiveCtrl.js, ml-credit-card-details.html

function MLCreditCardDetailsComponent(props) {
    const {
        jpmcURL,
        gpaMode,
        iframeHeight,
        iframeWidth,
        instrumentType,
        refreshAccountList,
        storeNewlyAddedCreditCard,
        markCreditCardForDeletion,
        onSave,
        onCancel,
        isDownPaymentInstrument,
        isSplMakePayment,
        setDownPaymentInstrumentById,
        setRecurringPaymentInstrumentById,
        refreshData,
        updateExistingCreditCard,
        isSplUser,
        setSaveCreditCard,
        setSelectedPaymentInstrument,
        isEditAccount,
        hideSaveAccountCheckbox
    } = props;

    const RECURRING_INSTRUMENT_TYPE = 'recurring';
    const DOWNPAYMENT_INSTRUMENT_TYPE = 'downpayment';
    const ONE_TIME_PAYMENT_TYPE = 'onetimepayment';
    const [isChecked, setIsChecked] = useState(false);
    const toggleIsChecked = (value) => {
        setIsChecked(!isChecked);
        setSaveCreditCard(value);
    };
    const REFRESH_DELAY = 500;

    const isQnB = appConfig.portalCode === 'QB';

    const iFrameWidthQB = isQnB ? '100%' : iframeWidth

    const getUrlQueryParams = (url) => {
        const splitRst = url.split('?');
        const params = {};
        if (splitRst[1]) {
            let query = splitRst[1];
            query = query.split('+').join(' ');

            const re = /[?&]?([^=]+)=([^&]*)/g;
            let tokens = [];

            tokens = re.exec(query);
            while (tokens !== null && tokens.length > 2) {
                const key = decodeURIComponent(tokens[1]);
                const value = decodeURIComponent(tokens[2]);
                params[key] = value;
                tokens = re.exec(query);
            }
        }
        return params;
    };

    const setHttpResponse = () => {
        let token = '';
        let url = '';
        try {
            url = document.getElementById('JpmcFrame').contentWindow.location.href;
        } catch (error) {
            // do nothing
        }

        const params = getUrlQueryParams(url);
        token = params.token;
        if (params?.DLAction === 'addAccount') {
            setTimeout(() => {
                refreshAccountList().then((pms) => {
                    let instruments = [];
                    if (pms.length > 0) {
                        if (Array.isArray(pms[0])) {
                            instruments = instruments.concat(pms[0]);
                            if (pms[1]) {
                                instruments = instruments.concat(pms[1]);
                            }
                        } else {
                            instruments = instruments.concat(pms);
                        }
                    }

                    if (!isSplMakePayment) {
                        if (instrumentType === DOWNPAYMENT_INSTRUMENT_TYPE) {
                            setDownPaymentInstrumentById(instruments, token);
                        } else if (instrumentType === RECURRING_INSTRUMENT_TYPE) {
                            setRecurringPaymentInstrumentById(instruments, token);
                        } else if (instrumentType === ONE_TIME_PAYMENT_TYPE) {
                            setSelectedPaymentInstrument(instruments, token);
                        }
                        if ((instrumentType === DOWNPAYMENT_INSTRUMENT_TYPE || instrumentType === ONE_TIME_PAYMENT_TYPE) && !isChecked) {
                            if (storeNewlyAddedCreditCard) {
                                storeNewlyAddedCreditCard(token);
                            }
                            if (markCreditCardForDeletion) {
                                markCreditCardForDeletion(token);
                            }
                        }
                        refreshData();
                        onSave(); // close modal popup
                    }
                });
            }, REFRESH_DELAY);
        } else if (params?.DLAction === 'editAccount') {
            setTimeout(() => {
                refreshAccountList().then((pms) => {
                    updateExistingCreditCard(token, pms);
                });
                onCancel();
            }, REFRESH_DELAY);
        } else if (params?.DLAction === 'cancel') {
            onCancel();
        }
    };

    const onLoadPaymentDetailsFrame = () => {
        setHttpResponse();
    };

    return (
        <div>
            {instrumentType !== 'recurring' && !isEditAccount && !isSplMakePayment && !hideSaveAccountCheckbox && (
                <div className={styles.checkboxRow}>
                    <CheckboxField
                        id='saveCreditCardCheckbox'
                        value={isChecked}
                        onValueChange={(e) => toggleIsChecked(e)}
                        label={gpaMode ? messages.SaveCreditCard : messages.ConsumerSaveCreditCard}
                        labelClassName={styles.labelStyle}
                        showInlineLabel
                    />
                </div>
            )}
             {instrumentType === 'recurring' && <div className='popupCloseDisclaimer'>{messages.PopeupCloseDisclaimer.defaultMessage}</div>}

            <IFrame
                id="JpmcFrame"
                title="Paymentus Iframe"
                src={jpmcURL}
                onLoad={onLoadPaymentDetailsFrame}
                height={iframeHeight}
                style={{width: `${iFrameWidthQB}`}}
                className={styles.JpmcFrame}
            />
        </div>
    );
}

MLCreditCardDetailsComponent.propTypes = {
    jpmcURL: PropTypes.string.isRequired,
    gpaMode: PropTypes.bool,
    iframeHeight: PropTypes.string,
    iframeWidth: PropTypes.string,
    instrumentType: PropTypes.string,
    refreshAccountList: PropTypes.func.isRequired,
    storeNewlyAddedCreditCard: PropTypes.func,
    markCreditCardForDeletion: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isDownPaymentInstrument: PropTypes.bool,
    isMakePayment: PropTypes.bool,
    setDownPaymentInstrumentById: PropTypes.func,
    setRecurringPaymentInstrumentById: PropTypes.func,
    updateExistingCreditCard: PropTypes.func,
    isSplUser: PropTypes.func,
    item: PropTypes.shape({}),
    setSaveCreditCard: PropTypes.func,
    setSelectedPaymentInstrument: PropTypes.func,
    isEditAccount: PropTypes.bool,
    hideSaveAccountCheckbox: PropTypes.bool
};

MLCreditCardDetailsComponent.defaultProps = {
    gpaMode: false,
    iframeHeight: '750px',
    iframeWidth: '100%',
    instrumentType: '',
    storeNewlyAddedCreditCard: _.noop,
    markCreditCardForDeletion: _.noop,
    isDownPaymentInstrument: undefined,
    isMakePayment: false,
    setDownPaymentInstrumentById: _.noop,
    setRecurringPaymentInstrumentById: _.noop,
    updateExistingCreditCard: _.noop,
    isSplUser: _.noop,
    item: {},
    setSaveCreditCard: _.noop,
    setSelectedPaymentInstrument: _.noop,
    isEditAccount: false,
    hideSaveAccountCheckbox: false
};

export default MLCreditCardDetailsComponent;
